/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ClockCheckIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Clock Check',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14 16.086V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v10.586a1 1 0 0 1-.293.707L12.1 23.9a1 1 0 0 1-1.414 0L9.35 22.565a1 1 0 0 1 0-1.414l4.358-4.358a1 1 0 0 0 .292-.707Z"
    />
    <path
      d="M15.763 31.988A14 14 0 1 1 29.669 15a12.185 12.185 0 0 1 2.143.68A15.992 15.992 0 1 0 16 34c.29 0 .573-.028.86-.044a12.309 12.309 0 0 1-1.097-1.968Z"
    />
    <path
      d="M27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9Zm-2.338 14.312-4.128-4.127a.5.5 0 0 1 0-.707l1.036-1.036a.5.5 0 0 1 .707 0l2.731 2.731 6.106-6.106a.5.5 0 0 1 .707 0l1.043 1.043a.5.5 0 0 1 0 .707l-7.5 7.5a.5.5 0 0 1-.702-.005Z"
    />
  </svg>`;
};
